export default __webpack_public_path__ + "static/cross-device-ad7df77d4bfb822d547eb03888ad22ca.png";